// extracted by mini-css-extract-plugin
export default {"modalWrapper":"GroupNameModal_modalWrapper__qEdXO"};